import React, { useEffect, useState } from "react";
import "./style.css";
import { Row, Col, Form } from "react-bootstrap";
import { MdRemoveCircle } from "react-icons/md";

const EditTest = (props) => {
  const [isCustomInput, setIsCustomInput] = useState(false);
  const [customInputValue, setCustomInputValue] = useState("");

  // Define options
  const options = props.options
    ? props.options.map((opt) => {
        return { label: opt, value: opt };
      })
    : props.testValue && props.testValue.indexOf("Reactive") !== -1
    ? [
        { label: "Non-Reactive", value: "Non-Reactive", key: "non-react" },
        { label: "Reactive", value: "Reactive", key: "react" },
      ]
    : [
        { label: "Not Detected", value: "Not Detected", key: "not-detected" },
        { label: "Detected", value: "Detected", key: "detected" },
      ];

  options.unshift({ label: "", value: "" });
  options.push({ label: "Other", value: "other" }); // Add 'Other' option

  const optionForms = options.map((opt) => (
    <option value={opt.value} key={opt.key}>
      {opt.label}
    </option>
  ));

  const updateTestValue = (value) => {
    if (value === "other") {
      setIsCustomInput(true);
      setCustomInputValue(""); // Clear the previous value
      props.updateValue(props.index, "", props.testId); // Clear value on selecting "Other"
    } else {
      setIsCustomInput(false);
      props.updateValue(props.index, value, props.testId);
    }
  };

  const handleCustomInputChange = (e) => {
    const value = e.target.value;
    setCustomInputValue(value);
    props.updateValue(props.index, value, props.testId);
  };

  const removeTest = () => {
    if (props.newTest && props.remove) {
      props.remove(props.index);
    }
  };

  useEffect(() => {}, []);

  return (
    <Row>
      <Col xs={6}>{props.testName}</Col>
      <Col>
        <Form.Control
          id="borderless"
          required
          value={isCustomInput ? "other" : props.testValue}
          as={"select"}
          onChange={(e) => updateTestValue(e.target.value)}
        >
          <option>Select result value*</option>
          {optionForms}
        </Form.Control>
        {/* Show text input if "Other" is selected */}
        {isCustomInput && (
          <Form.Control
            type="text"
            placeholder="Enter your value"
            value={customInputValue}
            onChange={handleCustomInputChange}
            style={{ marginTop: "10px" }}
          />
        )}
      </Col>
      {props.newTest ? (
        <Col xs={1}>
          <MdRemoveCircle onClick={removeTest} className="deleteIcon" />
        </Col>
      ) : (
        ""
      )}
    </Row>
  );
};

export default EditTest;
